export default __webpack_public_path__ + "static/media/Warlord's Spellsword.2d866c55.jpg";